<div class="Touchspin">
	<input
		type="number"
		min="1"
		[attr.max]="max ? max : null"
		name="quantity"
		[ngModel]="value"
		(ngModelChange)="update($event)"
		readonly
		pattern="^[0-9]+$"
		required
	>
	<button class="Touchspin_Btn Touchspin_Btn--reduce" type="button" (click)="decrease()"></button>
	<button class="Touchspin_Btn Touchspin_Btn--increase" type="button" (click)="increase()"></button>
</div>
